import React from 'react';
import './NetworkingLab.css';
import Navbar from '../../components/navbar';
import Footer from '../../components/Footer';
import PageHeader from '../../about/PageHeader';

const NetworkingLab = () => {
  return (
    <>
      <Navbar />
      <div className="net-lab-root-container">
        <PageHeader
          title="D-Link Academy Professional Networking Lab"
          crumbs={[{ label: "Home", href: "/" }, { label: "Life@TIMSCDR", href: "#" }, { label: "D-Link Academy Lab" }]}
        />
        <div className="net-lab-main-wrapper">
          <div className="net-lab-content-area">

          <div className="net-lab-primary-text-block">
            <div className="net-lab-text-segment">
              To become a globally recognized certified specialist in Networking, lab for Switches has been installed in association with <span className="net-lab-emphasis">D-link Academy Global Center of Excellence</span>. The lab provides the necessary infrastructure for D-Link Academy DCS Switches Certification.
            </div>
            
            <div className="net-lab-text-segment">
              <span className="net-lab-emphasis">Hands on Training programme</span> include network essentials, switch operation, VLAN, Spanning tree protocol, switch stacking, routing and switching feathers.
            </div>

            <div className="net-lab-text-segment">
              Faculty members underwent hands-on training for certifying in <span className="net-lab-emphasis">D-Link Academy DCS Switches Certification</span> in May 2017, provided by D-Link Academy.
            </div>
          </div>

          

          <div className="net-lab-visual-grid">
            <div className="net-lab-image-container">
              <img alt="Lab Session" className="net-lab-image-source" src="/images/dlink/01-D-link-1-scaled.jpg"/>
            </div>
            <div className="net-lab-image-container">
              <img alt="Network Rack" className="net-lab-image-source" src="/images/dlink/02-D-link-1-scaled.jpg"/>
            </div>
          </div>
        </div>
      </div>

      </div>
      <Footer />
    </>
  );
};

export default NetworkingLab;